// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"401a2c22","545":"d78cd236","645":"78099a8c","977":"f8978619"}[chunkId] + ".chunk.js";
};